import { gql } from "graphql-request";
import { User } from "../types/gql/graphql";
import Base from "./base";

class UserAPI extends Base {
	constructor(token: string) {
		super(token, "/api/account");
	}

	async getUser(): Promise<User> {
		const response = await this.graphQLRequest<{
			user: User[];
		}>(gql`
			{
				user {
					userId
					firstName
					lastName
					phoneNumber
					email
					status
					termsAccepted
					languageCode
					privateAccounts {
						accountId
						ownerId
						street
						zip
						city
						countryCode
						integrationKeys {
							key
							integrationType
							isEnabled
						}
						invitations {
							invitedUserId
							name
							phoneNumber
							invitationStatus
							validUntil
							invitedBy
						}
					}
					companyAccounts {
						accountId
						ownerId
						orgnumber
						name
						contactEmail
						contactPhone
						street
						zip
						city
						countryCode
						integrationKeys {
							key
							integrationType
							isEnabled
						}
						invitations {
							invitedUserId
							name
							phoneNumber
							invitationStatus
							validUntil
							invitedBy
						}
					}
					sharedAccounts {
						accountId
						accountName
						accountType
						privateAccountId
						privateAccount {
							accountId
							ownerId
							street
							zip
							city
							countryCode
							integrationKeys {
								key
								integrationType
								isEnabled
							}
						}
						companyAccountId
						companyAccount {
							accountId
							ownerId
							orgnumber
							name
							contactEmail
							contactPhone
							street
							zip
							city
							countryCode
							integrationKeys {
								key
								integrationType
								isEnabled
							}
						}
						userId
					}
					invitations(where: { invitationStatus: { _nin: [2, 3, 4] } }) {
						invitationStatus
						invitedBy
						accountName
						validUntil
						accountId
						companyAccountId
						privateAccountId
					}
				}
			}
		`);
		return response.user[0];
	}

	get userGraphQlRequest() {
		return `
			query {
				user {
					userId
					firstName
					lastName
					phoneNumber
					email
					status
					termsAccepted
					languageCode
					privateAccounts {
						accountId
						ownerId
						street
						zip
						city
						countryCode
						integrationKeys {
							key
							integrationType
							isEnabled
						}
						invitations {
							invitedUserId
							name
							phoneNumber
							invitationStatus
							validUntil
							invitedBy
						}
					}
					companyAccounts {
						accountId
						ownerId
						orgnumber
						name
						contactEmail
						contactPhone
						street
						zip
						city
						countryCode
						integrationKeys {
							key
							integrationType
							isEnabled
						}
						invitations {
							invitedUserId
							name
							phoneNumber
							invitationStatus
							validUntil
							invitedBy
						}
					}
					sharedAccounts {
						accountId
						accountName
						accountType
						privateAccountId
						privateAccount {
							accountId
							ownerId
							street
							zip
							city
							countryCode
							integrationKeys {
								key
								integrationType
								isEnabled
							}
						}
						companyAccountId
						companyAccount {
							accountId
							ownerId
							orgnumber
							name
							contactEmail
							contactPhone
							street
							zip
							city
							countryCode
							integrationKeys {
								key
								integrationType
								isEnabled
							}
						}
						userId
					}
					invitations(where: { invitationStatus: { _nin: [2, 3, 4] } }) {
						invitationStatus
						invitedBy
						accountName
						validUntil
						accountId
						companyAccountId
						privateAccountId
					}
				}
			}`;
	}

}

export default UserAPI;
